import React from 'react'

interface MetricCardProps {
  icon: React.ReactNode
  label: string
  value: string
  gradient: string
  loading?: boolean
  subtitle?: string
  alert?: boolean
}

export const MetricCard: React.FC<MetricCardProps> = ({
  icon,
  label,
  value,
  gradient,
  loading,
  subtitle,
  alert,
}) => {
  return (
    <div className={`rounded-xl shadow-md p-4 text-white ${gradient}`}>
      <div className="flex items-center gap-2 text-sm">
        {icon}
        <span>{label}</span>
      </div>
      <p
        className={`mt-2 text-2xl font-semibold ${alert ? 'text-red-200' : ''}`}
        aria-live="polite"
      >
        {loading ? (
          <span className="block h-6 w-24 rounded bg-white/40 animate-pulse" />
        ) : (
          value
        )}
      </p>
      {subtitle && <p className="text-xs mt-1 opacity-80">{subtitle}</p>}
    </div>
  )
}
